export default "__VITE_ASSET__eda1f844__"